module.exports = __webpack_public_path__ + "img/operator.054c4717.png";